import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const PrintLabelsDialog = ({
  labelDialogProduct, setLabelDialogProduct,
  labelVariants, setLabelVariants,
  downloadLabels,
  brands,
}) => {
  const getBrandName = (id) => brands.find(b => b.id === id)?.name || 'Unknown';

  return (
    <Dialog open={!!labelDialogProduct} onOpenChange={() => setLabelDialogProduct(null)}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Print Barcode Labels</DialogTitle>
          <DialogDescription>
            {labelDialogProduct?.design_code} — {getBrandName(labelDialogProduct?.brand_id)}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>{labelVariants.filter(v => v.selected).length} variants selected</span>
            <div className="flex gap-2">
              <button onClick={() => setLabelVariants(prev => prev.map(v => ({ ...v, selected: true })))} className="text-blue-600 hover:underline" data-testid="label-select-all">Select All</button>
              <button onClick={() => setLabelVariants(prev => prev.map(v => ({ ...v, selected: false })))} className="text-gray-600 hover:underline" data-testid="label-deselect-all">Deselect All</button>
            </div>
          </div>
          <div className="border rounded-lg overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-xs">
                <tr>
                  <th className="p-2 text-left w-8"></th>
                  <th className="p-2 text-left">Color</th>
                  <th className="p-2 text-left">Size</th>
                  <th className="p-2 text-left">SKU</th>
                  <th className="p-2 text-right w-24">Qty (labels)</th>
                </tr>
              </thead>
              <tbody>
                {labelVariants.map((v, i) => (
                  <tr key={i} className={`border-t ${v.selected ? '' : 'opacity-40'}`}>
                    <td className="p-2">
                      <input type="checkbox" checked={v.selected}
                        onChange={e => setLabelVariants(prev => prev.map((x, j) => j === i ? { ...x, selected: e.target.checked } : x))}
                        data-testid={`label-check-${i}`} />
                    </td>
                    <td className="p-2 font-medium">{v.color}</td>
                    <td className="p-2">{v.size}</td>
                    <td className="p-2 text-xs text-gray-500 font-mono">{v.sku_code}</td>
                    <td className="p-2">
                      <Input type="number" min="0" value={v.qty}
                        onChange={e => setLabelVariants(prev => prev.map((x, j) => j === i ? { ...x, qty: parseInt(e.target.value) || 0 } : x))}
                        className="h-7 w-20 text-right text-sm ml-auto" data-testid={`label-qty-${i}`} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-between pt-2">
            <span className="text-sm text-gray-500">
              Total labels: <strong>{labelVariants.filter(v => v.selected).reduce((s, v) => s + (v.qty || 0), 0)}</strong>
            </span>
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => downloadLabels('excel')} data-testid="label-excel-btn">
                <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                Excel
              </Button>
              <Button onClick={() => downloadLabels('pdf')} className="bg-blue-600 hover:bg-blue-700" data-testid="label-generate-btn">
                <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>
                PDF
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrintLabelsDialog;
